import { Link } from "react-router-dom";
import { Label } from "expano-components";

const ChannelsList = ({ data, channel_id }) => {
  return (
    <div className="channels-list lg">
      {data
        .sort((a, b) => a.identifier.localeCompare(b.identifier))
        .map(({ id, identifier, shop, platform }) => (
          <Link
            key={identifier}
            className={String(id) === String(channel_id) ? "active" : ""}
            to={`/campaigns/channels${id ? `/${id}` : ""}`}
          >
            <span>{identifier}</span>
            <Label
              type="double"
              left={{
                text: shop?.label_text,
                color: `#${shop?.label_color}`,
              }}
              right={{
                text: platform?.label_text,
                color: `#${platform?.label_color}`,
              }}
            />
            <button
              type="button"
              className="btn btn-sm btn-blue"
              onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
                window.open(`/channels/${channel_id}`, "_blank");
              }}
            >
              <svg
                height="12px"
                width="12px"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 472.615 472.615"
              >
                <path
                  d="M472.615,274.117V198.4l-55.335-9.255c-4.332-16.64-10.929-32.492-19.692-47.458L430.178,96l-53.563-53.563
			l-45.686,32.591c-14.966-8.763-30.917-15.36-47.557-19.692L274.215,0H198.4l-9.157,55.335
			c-16.64,4.332-32.591,10.929-47.557,19.692L96,42.437L42.437,96l32.591,45.686c-8.763,14.966-15.36,30.818-19.692,47.458L0,198.4
			v75.717l55.335,9.255c4.332,16.64,10.929,32.591,19.692,47.557l-32.591,45.686L96,430.178l45.686-32.689
			c14.966,8.862,30.917,15.458,47.557,19.791l9.157,55.335h75.815l9.157-55.335c16.64-4.332,32.591-10.929,47.557-19.791
			l45.686,32.689l53.563-53.563l-32.591-45.686c8.763-14.966,15.36-30.917,19.692-47.557L472.615,274.117z M236.308,334.769
			c-54.252,0-98.462-44.209-98.462-98.462c0-54.351,44.209-98.462,98.462-98.462s98.462,44.111,98.462,98.462
			C334.769,290.56,290.56,334.769,236.308,334.769z"
                  fill="#fff"
                />
              </svg>
            </button>
          </Link>
        ))}
    </div>
  );
};

export default ChannelsList;
